module.exports = __webpack_public_path__ + "img/story002@2x.ca7edef1.png";